/**
 * @generated SignedSource<<c53e6fc4299d5250a9f34ae3b927fc29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
export type TodoOverviewListItemSetStatusMutation$variables = {
  newStatus: TodoStatus;
  todoId: string;
};
export type TodoOverviewListItemSetStatusMutation$data = {
  readonly todo: {
    readonly updateTodoItemStatus: {
      readonly todo: {
        readonly id: string;
        readonly lastChangedStatusAt: string | null;
        readonly lastChangedStatusBy: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly status: TodoStatus;
      };
    };
  } | null;
};
export type TodoOverviewListItemSetStatusMutation = {
  response: TodoOverviewListItemSetStatusMutation$data;
  variables: TodoOverviewListItemSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "todoId",
        "variableName": "todoId"
      }
    ],
    "concreteType": "TodoMutation",
    "kind": "LinkedField",
    "name": "todo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "newStatus"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "UpdateTodoItemPayload",
        "kind": "LinkedField",
        "name": "updateTodoItemStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "lastChangedStatusBy",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastChangedStatusAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoOverviewListItemSetStatusMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoOverviewListItemSetStatusMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "da6cf3b35204643313ff237c35d97140",
    "id": null,
    "metadata": {},
    "name": "TodoOverviewListItemSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation TodoOverviewListItemSetStatusMutation(\n  $todoId: ID!\n  $newStatus: TodoStatus!\n) {\n  todo(todoId: $todoId) {\n    updateTodoItemStatus(input: {status: $newStatus}) {\n      todo {\n        id\n        status\n        lastChangedStatusBy {\n          id\n          name\n        }\n        lastChangedStatusAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4d11f3450014a592544ebf1c112a7da";

export default node;
